import React from 'react';
import styled from 'styled-components';

const MenuWrapper = styled.div.attrs(props => ({
  style: {
    top: `${props.y}px`,
    left: `${props.x}px`,
  },
}))`
  position: fixed;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 1000;
  min-width: 150px;
`;

const MenuItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  &:hover {
    background-color: #f1f1f1;
  }
`;

const ContextMenu = ({ menuState }) => {
  if (!menuState.visible) {
    return null;
  }

  return (
    <MenuWrapper x={menuState.x} y={menuState.y}>
      {menuState.options.map(option => (
        <MenuItem key={option.label} onClick={option.action}>
          {option.label}
        </MenuItem>
      ))}
    </MenuWrapper>
  );
};

export default ContextMenu;